const now = new Date()



function genNoWork() {
    let noWork = [
        [1, 1, 26],
        [11, 27, 25],
        [9, 1, 25],
        [11, 11, 25],
        [12, 25, 25],


    ]
    return noWork.map(day => {

        return {

            allday: true,
            title: 'No Work',
            start: new Date(2000 + day[2], day[0] - 1, day[1], 0, 0, 0),
            end: new Date(2000 + day[2], day[0] - 1, day[1] + 1, 0, 0, 0)
        }
    })

}

function genGLC() {
    let glc = [
        [9, 6, 25],


    ]
    return glc.map(day => {

        return {

            allday: true,
            title: 'GLC',
            start: new Date(2000 + day[2], day[0] - 1, day[1], 0, 0, 0),
            end: new Date(2000 + day[2], day[0] - 1, day[1] + 1, 0, 0, -1000)
        }
    })

}

function genNoSchool() {
    let noSchoolDays = [
        [9, 7, 26],
        [9, 21, 26],
        [10, 16, 26],
        [11, 2, 26],
        [11, 3, 26],




        [1, 18, 27],
        [1, 25, 27],
        [2, 15, 27],

        [3, 9, 27],

        [4, 12, 27],
        [4, 22, 27],
        [5, 17, 27],
        [5, 31, 27],


    ]
    return noSchoolDays.map(day => {

        return {

            allday: true,
            title: 'No School',
            start: new Date(2000 + day[2], day[0] - 1, day[1], 0, 0, 0),
            end: new Date(2000 + day[2], day[0] - 1, day[1], 0, 0, 0)
        }
    })

}

export default [

    ...genNoSchool(),
    ...genGLC(),
    ...genNoWork(),
    {

        allday: true,
        title: 'Early Release',
        start: new Date("9/18/2026"),
        end: new Date("9/18/2026")
    },
    {

        allday: true,
        title: 'Early Release',
        start: new Date("11/23/2026"),
        end: new Date("11/23/2026")
    },
    {

        allday: true,
        title: 'Early Release',
        start: new Date("11/24/2026"),
        end: new Date("11/24/2026")
    },
    {

        allday: true,
        title: 'Early Release',
        start: new Date("11/25/2026"),
        end: new Date("11/25/2026")
    },
    {

        allday: true,
        title: 'Early Release',
        start: new Date("12/23/2026"),
        end: new Date("12/23/2026")
    },
    {

        allday: true,
        title: 'Early Release',
        start: new Date("2/26/2027"),
        end: new Date("2/26/2027")
    },
    {

        allday: true,
        title: 'Early Release - Last Day',
        start: new Date("6/17/2026"),
        end: new Date("6/17/2026")
    },
    {

        allday: true,
        title: 'Early Release',
        start: new Date("6/18/2026"),
        end: new Date("6/18/2026")
    },
    {

        allday: true,
        title: 'Parents',
        start: new Date("6/22/2026"),
        end: new Date("6/26/2026")
    },
    {

        allday: true,
        title: 'BarT',
        start: new Date("8/17/2026"),
        end: new Date("8/21/2026")
    },

    {

        allday: true,
        title: 'First Day of School',
        start: new Date("8/25/2026"),
        end: new Date("8/25/2026")
    },


    {

        allday: true,
        title: 'Woodland Camp',
        start: new Date("8/3/2026"),
        end: new Date("8/7/2026")
    },
    {

        allday: true,
        title: 'Makeup days',
        start: new Date("6/14/2027"),
        end: new Date("6/18/2027")
    },
    {

        allday: true,
        title: 'Spring Break',
        start: new Date("3/26/2027"),
        end: new Date("4/4/2027")
    },
    {

        allday: true,
        title: 'Christmas Break',
        start: new Date("12/24/2026"),
        end: new Date("1/3/2027")
    },
    {

        allday: true,
        title: 'Thanksgiving Break',
        start: new Date("11/26/2026"),
        end: new Date("11/29/2026")
    },



    /*
    {

        allday: true,
        title: 'Beth Weekend',
        private: true,
        start: new Date("10/18/2025"),
        end: new Date("10/22/2025")
    },
    {
        allday: true,
        title: 'Ren Fest',
        start: new Date("10/5/2025"),
        private: true,
        end: new Date("10/5/2025")
    },
    {
        allday: true,
        title: 'Beth Date',
        start: new Date("9/5/2025"),
        private: true,
        end: new Date("9/5/2025")
    },
    {
        allday: true,
        title: 'Beth`s Katie',
        start: new Date("9/19/2025"),
        private: true,
        end: new Date("9/20/2025")
    },
    {
        allday: true,
        title: 'Glazing',
        start: new Date('10/3/2025'),
        private: true,
        end: new Date('10/3/2025')
    },

*/

]